// extracted by mini-css-extract-plugin
export var button = "formPrime-module--button--93724";
export var cards = "formPrime-module--cards--07aa5";
export var error = "formPrime-module--error--1d19a";
export var instructions = "formPrime-module--instructions--e98ef";
export var loader = "formPrime-module--loader--50e19";
export var spin = "formPrime-module--spin--91127";
export var store = "formPrime-module--store--609fb";
export var textForm = "formPrime-module--textForm--a4692";